// Request util for api call
import request from '~/utils/request';

// Actions Types
import { SET_ADMIN_LOOKUPS_DATA, SET_ADMIN_LOOKUPS_LOADER } from './action-types';

// Utils
import { DEFAULT_PAGINATION } from '~/utils/constants';

const fetchOrderItemLookups = (payload) => async (dispatch) => {
  try {
    let queryPayload = {
      page: payload?.pagination?.page ? payload.pagination.page : DEFAULT_PAGINATION.page,
      pageSize: payload?.pagination?.pageSize
        ? payload.pagination.pageSize
        : DEFAULT_PAGINATION.pageSize,
    };

    if (payload?.barcode?.length) {
      queryPayload.barcode = payload.barcode;
    }

    if (payload?.applyFilters) {
      Object.entries(payload.filters).forEach(([key, value]) => {
        if (key === 'mailedDate') {
          if (value) {
            let date = Object?.entries(value)
              .map(([nestedKey, nestedValue]) => `${JSON.stringify(nestedKey)}:${JSON.stringify(nestedValue)}`)
              .join(', ');
            queryPayload[key] = `{${date}}`;
          }
        } else if (value !== null && value !== undefined && `${value}`.length) {
          queryPayload[key] = value;
        }
      });
    }

    dispatch({ type: SET_ADMIN_LOOKUPS_LOADER, payload: true });
    const response = await request.get('admin/order-items', queryPayload);
    dispatch({ type: SET_ADMIN_LOOKUPS_DATA, payload: response.data.data });
    return response;
  } catch (error) {
    return error.response;
  } finally {
    dispatch({ type: SET_ADMIN_LOOKUPS_LOADER, payload: false });
  }
};

export { fetchOrderItemLookups };
